import { tv } from "../../../variants/tv.js";
const radioSizeVariants = {
    16: {
        labelSlot: 'text-body3',
        radioRoot: 'w-4 h-4',
        radioIndicator: 'before:w-[6px] before:h-[6px]'
    },
    20: {
        labelSlot: 'text-body2',
        radioRoot: 'w-5 h-5',
        radioIndicator: 'before:w-[8px] before:h-[8px]'
    },
    24: {
        labelSlot: 'text-body1',
        radioRoot: 'w-6 h-6',
        radioIndicator: 'before:w-[10px] before:h-[10px]'
    }
};
const radioSizes = Object.keys(radioSizeVariants);
const RadioEmphasisVariants = {
    regular: {
        labelSlot: 'text-primary-13',
        radioRoot: [
            'bg-primary-1 border border-primary-6 ',
            'hover:border-primary-10 group-hover/control:border-primary-10 focus-visible:outline-primary-8',
            'data-checked:bg-primary-8 data-checked:border-primary-8',
            'hover:data-checked:bg-primary-9 hover:data-checked:border-primary-9',
            'group-hover/control:data-checked:bg-primary-9 group-hover/control:data-checked:border-primary-9'
        ],
        radioIndicator: 'data-checked:before:bg-primary-1 data-disabled:data-checked:before:bg-primary-6',
        helperSlot: 'text-primary-1 group-[.disabled]:text-primary-1/40',
        textRightSlot: 'text-primary-10 group-[.disabled]:text-primary-1/40'
    },
    medium: {
        labelSlot: 'text-primary-13',
        radioRoot: [
            'bg-primary-1/60 border border-primary-6',
            'hover:border-primary-10 group-hover/control:border-primary-10 focus-visible:outline-primary-8',
            'data-checked:bg-primary-8 data-checked:border-primary-8',
            'hover:data-checked:bg-primary-9 hover:data-checked:border-primary-9',
            'group-hover/control:data-checked:bg-primary-9 group-hover/control:data-checked:border-primary-9'
        ],
        radioIndicator: 'data-checked:before:bg-primary-1 data-disabled:data-checked:before:bg-primary-6',
        helperSlot: 'text-primary-1 group-[.disabled]:text-primary-1/40',
        textRightSlot: 'text-primary-10 group-[.disabled]:text-primary-1/40'
    },
    bold: {
        labelSlot: 'text-primary-1',
        radioRoot: [
            'bg-primary-1/20 border border-primary-1/40',
            'hover:border-primary-1 group-hover/control:border-primary-1 focus-visible:outline-primary-1',
            'data-checked:bg-primary-1 data-checked:border-primary-1',
            'hover:data-checked:bg-primary-1/80  hover:data-checked:border-primary-1/80',
            'group-hover/control:data-checked:bg-primary-1/80 group-hover/control:data-checked:border-primary-1/80'
        ],
        radioIndicator: 'data-checked:before:bg-primary-8 data-disabled:data-checked:before:bg-primary-1/40',
        helperSlot: 'text-primary-1 group-[.disabled]:text-primary-1/40',
        textRightSlot: 'text-primary-10 group-[.disabled]:text-primary-1/40'
    }
};
const RadioDisabledStateVariants = {
    false: {
        containerSlot: 'group',
        helperSlot: 'text-primary-13 relative cursor-pointer',
        textRightSlot: 'cursor-pointer text-primary-10'
    },
    true: {
        containerSlot: 'group data-disabled:cursor-not-allowed',
        helperSlot: 'text-primary-6 has-data-disabled:cursor-not-allowed',
        textRightSlot: 'text-primary-6 has-data-disabled:cursor-not-allowed',
        imageSlot: 'has-data-disabled:cursor-not-allowed'
    }
};
const radioEmphases = Object.keys(RadioEmphasisVariants);
const radioButtonVariants = tv({
    slots: {
        containerSlot: 'flex flex-1 flex-col items-start text-left has-data-disabled:cursor-not-allowed',
        labelSlot: 'group/control flex cursor-pointer flex-row gap-2 has-data-disabled:cursor-not-allowed',
        radioRoot: 'inline-flex cursor-pointer items-center justify-center rounded-full transition group-hover/control:shadow-input-hover hover:shadow-input-hover focus-visible:outline-2 focus-visible:outline-offset-2 data-checked:transition data-disabled:cursor-not-allowed data-disabled:shadow-none data-disabled:group-hover/control:shadow-none',
        radioIndicator: 'flex transition before:rounded-full data-checked:transition data-unchecked:hidden',
        iconSlot: 'no-underline transition group-hover:no-underline hover:no-underline',
        helperSlot: 'display-block items-normal flex w-full text-left text-body3 leading-tight has-data-disabled:cursor-not-allowed',
        textRightSlot: 'ml-auto flex shrink-0 justify-end pt-0 text-body3 text-primary-10 has-data-disabled:cursor-not-allowed',
        imageSlot: 'inline-block self-center has-data-disabled:cursor-not-allowed'
    },
    variants: {
        emphasis: RadioEmphasisVariants,
        size: radioSizeVariants,
        disabled: RadioDisabledStateVariants,
        isRadioGroup: {
            true: {}
        },
        layout: {
            vertical: {},
            horizontal: {}
        }
    },
    compoundVariants: [
        {
            isRadioGroup: true,
            layout: 'vertical',
            class: {
                labelSlot: 'w-full'
            }
        },
        {
            disabled: true,
            emphasis: 'regular',
            class: {
                labelSlot: 'text-primary-6',
                radioRoot: [
                    'border-primary-5 bg-primary-2 group-hover/control:border-primary-5 hover:border-primary-5',
                    'data-checked:border-primary-2 data-checked:bg-primary-2',
                    'hover:data-checked:border-primary-2 hover:data-checked:bg-primary-2',
                    'group-hover/control:data-checked:border-primary-2 group-hover/control:data-checked:bg-primary-2'
                ]
            }
        },
        {
            disabled: true,
            emphasis: 'medium',
            class: {
                labelSlot: 'text-primary-6',
                radioRoot: [
                    'border-primary-5 bg-primary-1/60 group-hover/control:border-primary-5 hover:border-primary-5',
                    'data-checked:border-primary-1/60 data-checked:bg-primary-1/60',
                    'hover:data-checked:border-primary-1/60 hover:data-checked:bg-primary-1/60',
                    'group-hover/control:data-checked:border-primary-1/60 group-hover/control:data-checked:bg-primary-1/60'
                ]
            }
        },
        {
            disabled: true,
            emphasis: 'bold',
            class: {
                labelSlot: 'text-primary-1/40',
                radioRoot: [
                    'border-primary-1/20 bg-primary-1/20 group-hover/control:border-primary-1/20 hover:border-primary-1/20',
                    'data-checked:border-primary-1/20 data-checked:bg-primary-1/20',
                    'hover:data-checked:border-primary-1/20 hover:data-checked:bg-primary-1/20',
                    'group-hover/control:data-checked:border-primary-1/20 group-hover/control:data-checked:bg-primary-1/20'
                ]
            }
        }
    ],
    defaultVariants: {
        emphasis: 'regular',
        size: '20',
        disabled: false,
        isRadioGroup: false,
        layout: 'vertical'
    }
});
export { RadioDisabledStateVariants, RadioEmphasisVariants, radioButtonVariants, radioEmphases, radioSizeVariants, radioSizes };
